import { render, staticRenderFns } from "./PlayerRanking.vue?vue&type=template&id=3f5fb0e3"
import script from "./PlayerRanking.vue?vue&type=script&lang=js"
export * from "./PlayerRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports